import React from 'react';
import Card from 'components/fullWidthCard';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class DatabaseTools extends React.Component {
  static displayName = 'DatabaseTools';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  render() {
    let {formatMessage} = this.props.intl;

    return <div className='container scanner-tools'>
      <Card title={formatMessage({id: 'tools.database.customer.upload'})}
            link='#tools/upload'
            right={<a className='btn btn-primary pull-right'
                      href='#tools/upload'><FormattedMessage id="general.upload"/></a>}
            body={formatMessage({id: 'tools.database.customer.description'})}/>
      <Card title={formatMessage({id: 'tools.database.download.database'})}
            link='#tools/export'
            right={<a className='btn btn-primary pull-right'
                      href='#tools/export'><FormattedMessage id="general.export"/></a>}
            body={formatMessage({id: 'tools.database.download.description'})}/>
      <Card title={formatMessage({id: 'tools.database.email.upload'})}
            link='#tools/uploadEmail'
            right={<a className='btn btn-primary pull-right'
                      href='#tools/uploadEmail'><FormattedMessage id="general.upload"/></a>}
            body={formatMessage({id: 'tools.database.email.description'})}/>
    </div>;
  }
}

export default injectIntl(DatabaseTools);
